import type { ILogService } from "angular";

import type { IResponseWithLoading } from "App/Modules/Models";

import type { ILoadingErrorComponentController } from "./ILoadingErrorComponentController";

export class LoadingErrorComponentController implements ILoadingErrorComponentController {
    public static $inject = ["$transclude", "$log"];

    public response: IResponseWithLoading<void>;

    constructor(private $log: ILogService) {}
}
